import {Form} from 'antd'
import {InputText, Select} from '@/components/Form/index.mjs'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemBdName, FormItemBdNo} from '../BD/FormChooseBd.jsx'

const FormItemAlgTitle = props => (
    <Form.Item
        label="方法标题"
        name="algTitle"
        {...props}
    >
        <InputText allowClear />
    </Form.Item>
)

const FormItemAlgType = props => (
    <Form.Item
        label="方法类型"
        name="algType"
        {...props}
    >
        <Select
            allowClear
            getOptionKey={e => e[0]}
            getOptionLabel={e => e[1]}
            options={[['基础', 'BASE'], ['事件', 'DEVELOP']]}
        />
    </Form.Item>
)

export default function FormChooseBdalg(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemBdNo />
            <FormItemBdName />
            <FormItemAlgTitle />
            <FormItemAlgType />
        </FormChooseDesign>
    )
}
